<template>
    <div>
        <div class="topbar">
            <startups></startups>

            <div class="topbar__inner">
                <div class="topbar__key">
                    <header class="topbar__key__header">
                        Show
                        <select v-if="totalRowsCount >= 25" class="topbar__key__select" v-model="pageLength">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                        <template v-else>{{totalRowsCount}}</template>
                        of {{totalRowsCount}} portfolios
                    </header>

                    <footer class="topbar__key__footer">
                        <ul class="topbar__side actions-list">
                            <li class="actions-list__add"><a @click="addPortfolio">Create a Portfolio</a></li>
                        </ul>
                    </footer>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper overflow-auto">
            <div class="main-table">
                <Grid
                    :columns="columns"
                    :data="portfolios"
                    :addCellData="addCellData"
                    :page-length="parseInt(pageLength)"
                    :total-rows-count="totalRowsCount"
                    :sort="sort"
                    :currentPage="currentPage"
                    v-on:changePage="changePage"
                    v-on:changeSort="changeSort"
                    v-on:action="gridAction"
                >
                </Grid>
            </div>
        </div>

        <edit-portfolio
            ref="editPortfolio"
            v-on:saved="getList"
        >
        </edit-portfolio>

        <share-portfolio
            ref="sharePortfolio"
            v-on:saved="getList"
        >
        </share-portfolio>
    </div>
</template>

<script>
import grid from "@/mixins/grid";
import portfolios from "@/services/ecosystem/portfolios.service";
import Grid from "@/components/Grid";
import EditPortfolio from "@/components/portfolios/EditPortfolio";
import SharePortfolio from "@/components/portfolios/SharePortfolio";
import Startups from "@/views/ecosystem/Startups";

export default {
    mixins: [grid],

    components: {
        Grid,
        EditPortfolio,
        SharePortfolio,
        Startups,
    },

    data() {
        return {
            portfolios: [],

            columns: [
                {
                    label: 'Name',
                    name: 'name',
                    component: 'RouterLinkColumn',
                },
                {
                    label: 'Description',
                    name: 'description',
                },
                {
                    label: 'Startups',
                    name: 'startups_count',
                },
                {
                    label: 'Enterprises shared',
                    name: 'enterprises_count',
                },
                {
                    name: 'actions',
                    label: 'Actions',
                    component: 'Actions',
                }
            ],

            addCellData: {
                companyType: "startups",
            },
        }
    },

    mounted() {
        this.getList()
    },

    methods: {
        getList() {
            let columns = this.arrayHelper.arrayColumn(this.columns, 'name')
            let currentPage = this.currentPage
            let pageLength = this.pageLength
            let sort = this.sort

            portfolios.getPortfolios({columns, sort, currentPage, pageLength}).then(response => {
                this.portfolios = response.data.data
                this.totalRowsCount = parseInt(response.data.total_count)
                this.currentPage = response.data.current_page
            })
        },

        gridAction(params) {
            if (params.action == 'edit') {
                this.$refs.editPortfolio.open(params.rowId)
            }

            if (params.action == 'share') {
                this.$refs.sharePortfolio.open(params.rowId)
            }
        },

        addPortfolio() {
            this.$refs.editPortfolio.open(0)
        }
    }
}
</script>

<style scoped>

</style>